import { history } from '../state/configureStore';

export const ErrorCodes = {
  TOO_MUCH_TIME_AWAY: 'A7-1140',
  DEVICE_CONCURRENCY: 'A7-3321',
  DEVICE_LOGGED_OUT: 'A7-3325',
  DEVICE_TOKEN_EXPIRED: 'A7-3315',
  DEFAULT_LOGOUT_ERROR: 'A7-3316',
};

export const ErrorMessages = {
  [ErrorCodes.TOO_MUCH_TIME_AWAY]: 'auth.errors.generic',
  [ErrorCodes.DEVICE_CONCURRENCY]: 'auth.errors.concurrency',
  [ErrorCodes.DEVICE_LOGGED_OUT]: 'auth.errors.generic',
  [ErrorCodes.DEVICE_TOKEN_EXPIRED]: 'auth.errors.generic',
  [ErrorCodes.DEFAULT_LOGOUT_ERROR]: 'auth.errors.generic',
};

export const getErrorDetails = (code, status, details) => {
  let errorCode = ErrorCodes.DEFAULT_LOGOUT_ERROR;

  if (code === ErrorCodes.TOO_MUCH_TIME_AWAY) {
    errorCode = ErrorCodes.TOO_MUCH_TIME_AWAY;
  } else if (status === '401') {
    if (details === 'TOKEN_ALREADY_LOGGED_OUT') {
      errorCode = ErrorCodes.DEVICE_LOGGED_OUT;
    } else if (code === 'DTV-007') {
      errorCode = ErrorCodes.DEVICE_CONCURRENCY;
    }
  }

  if (details === 'TOKEN_EXPIRED') {
    errorCode = ErrorCodes.DEVICE_TOKEN_EXPIRED;
  }

  let errorCodeWithDetails;

  if (errorCode === ErrorCodes.TOO_MUCH_TIME_AWAY) {
    errorCodeWithDetails = errorCode;
  } else if (code) {
    errorCodeWithDetails = `${errorCode} (${code})`;
  } else if (status) {
    errorCodeWithDetails = `${errorCode} (${status})`;
  } else {
    errorCodeWithDetails = errorCode;
  }

  const errorMessage = ErrorMessages[errorCode];

  return { errorMessage, errorCodeWithDetails };
};

export const redirectToAuthErrorPage = (error) => {
  const { code, details } = error?.response?.data || {};
  const { status } = error?.response || {};
  history.push(
    `/user/error?
    ${code ? `error=${code}&` : ''}
    ${status ? `status=${status}&` : ''}
    ${details ? `details=${details}` : ''}
  `.replace(/&$/, '').replace(/\s/g, ''),
  );
};
